export default __webpack_public_path__ + "static/media/banner.490d2eb6.jpg";